import React from 'react';

const ProjectStatusBadge = ({ status }) => {
  const statusConfig = {
    'Planning': {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      label: 'Planning'
    },
    'Bidding': {
      bg: 'bg-purple-100 dark:bg-purple-900/30',
      text: 'text-purple-700 dark:text-purple-300',
      label: 'Bidding'
    },
    'In Progress': {
      bg: 'bg-amber-100 dark:bg-amber-900/30',
      text: 'text-amber-700 dark:text-amber-300',
      label: 'In Progress'
    },
    'On Hold': {
      bg: 'bg-gray-100 dark:bg-gray-800',
      text: 'text-gray-700 dark:text-gray-300',
      label: 'On Hold'
    },
    'Completed': {
      bg: 'bg-green-100 dark:bg-green-900/30',
      text: 'text-green-700 dark:text-green-300',
      label: 'Completed'
    },
    'Cancelled': {
      bg: 'bg-red-100 dark:bg-red-900/30',
      text: 'text-red-700 dark:text-red-300',
      label: 'Cancelled'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.['Planning'];

  return (
    <span className={`inline-flex items-center px-2 py-1 md:px-3 md:py-1.5 rounded-full text-xs md:text-sm font-medium ${config?.bg} ${config?.text}`}>
      {config?.label}
    </span>
  );
};

export default ProjectStatusBadge;